import { useState, useCallback } from "react";

type Severity = "success" | "error" | "warning" | "info";

export interface SnackbarState {
  open: boolean;
  message: string;
  severity: Severity;
}

export function useDevSnackbar() {
  const [state, setState] = useState<SnackbarState>({
    open: false,
    message: "",
    severity: "success",
  });

  const show = useCallback((message: string, severity: Severity = "success") => {
    setState({ open: true, message, severity });
  }, []);

  const hide = useCallback(() => {
    setState(prev => ({ ...prev, open: false }));
  }, []);

  return { ...state, show, hide };
}
